import { getLink, trans } from "~/providers/lang";
import GalleryEnter from "~/components/GalleryEnter";
import { ROUTES, GALLERY_PREVIEW_LARGE_COUNT } from '~/const';
import { mainStore } from "~/stores/main";
import { useSeo } from "~/hooks/useSeo";

import "./style.less";

export default function FormalPage() {
	useSeo({
		title: trans("skelet.title.formal"),
		canonical: "spolecenske-saty",
	});

	const pageData = mainStore(state => state.data.pageData);
	const items = pageData.photos.formal[0].slice(0, GALLERY_PREVIEW_LARGE_COUNT);

	return <>
		<div className="body-background">
			<div className="formal-page page-content top-shadow">
				<h1 className="other-page-title">
					{trans('formal.title')}
				</h1>
				<div className="row">
					<div className="col-md-12">
						<p className="desc">
							{trans('formal.desc')}
						</p>
					</div>
				</div>
				<GalleryEnter link={getLink(ROUTES.galleryFormal)} items={items} />
			</div>
		</div>
	</>;
}
